/**
 * Mock de usuarios registrados por tipo.
 */

export interface UserTypeCount {
  type: string;
  label: string;
  count: number;
}

export const MOCK_USERS_BY_TYPE: UserTypeCount[] = [
  { type: "physician", label: "Médicos", count: 128 },
  { type: "patient", label: "Pacientes", count: 4520 },
  { type: "institution", label: "Clínicas", count: 36 },
  { type: "auxiliary", label: "Auxiliares", count: 84 },
];

export const MOCK_USERS_REGISTERED_TODAY = 23;
